<template>
  <v-card
    class="service-dialog"
  >
    <v-card-title class="service-dialog__close pa-0">
      <v-btn
        icon
      >
        <v-icon
          small
          @click="close"
        >
          close
        </v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text
      class="pa-0 service-dialog__title"
    >
      Complemente a sua compra
    </v-card-text>

    <v-card-text
      class="pa-0 my-1 mb-4 service-dialog__txt"
    >
      Complemente a sua compra com a seleção de serviços exclusivos Angeloni.
    </v-card-text>

    <v-form
      v-model="valid"
    >
      <!-- Desabilitado para V0 (por padrão vem a opção todas as unidades selecionadas) -->
      <!-- <v-autocomplete
        v-if="quantity > 1"
        v-model="unitiesToApply"
        :items="getQuantities"
        label="Para quantas unidades deseja aplicar?"
        required
      /> -->

      <v-container
        fluid
        class="dialog-checkbox"
      >
        <v-checkbox
          v-model="selectedNoService"
          color="black"
          :disabled="!!selectedServices.length"
        >
          <template #label>
            <div class="dialog-checkbox__wrapper">
              <span
                class="dialog-checkbox__wrapper__title"
              >
                Não desejo nenhum serviço
              </span>
              <span
                class="dialog-checkbox__wrapper__txt"
              >
                Danos causados por instalações e manutenções não credenciadas implicam na perda de garantia.
                <!-- <a
                  target="_blank"
                  href="https://vuetifyjs.com"
                  class="dialog-checkbox__wrapper__link"
                >
                  Veja o termo.
                </a> -->
              </span>
            </div>
          </template>
        </v-checkbox>
      </v-container>

      <v-container
        v-for="(service, index) in getServices"
        :key="index"
        fluid
        class="my-3 dialog-checkbox"
      >
        <v-checkbox
          v-model="selectedServices"
          :value="service"
          color="black"
          :disabled="selectedNoService"
        >
          <template #label>
            <div class="dialog-checkbox__wrapper">
              <span
                class="dialog-checkbox__wrapper__title"
              >
                {{ service.title }}
              </span>
              <span
                class="dialog-checkbox__wrapper__txt"
              >
                {{ service.subtitle }}
              </span>
            </div>
            <div class="dialog-checkbox__wrapper">
              <span
                class="dialog-checkbox__wrapper__title"
              >
                {{ service.price | currency }}
              </span>
              <span
                class="dialog-checkbox__wrapper__txt"
              >
                {{ service.installments }}
              </span>
            </div>
          </template>
        </v-checkbox>
      </v-container>

      <!-- to be used in upcoming versions of sales assistant -->
      <!-- <v-container
        fluid
        class="dialog-conditions"
      >
        <v-checkbox
          v-model="selectedTerms"
          color="black"
          :rules="[(v) => !!v || 'Campo Obrigatório!']"
        >
          <template
            #label
            required
          >
            <div
              class=" pl-2 dialog-conditions__txt"
            >
              Li e aceito os
              <a
                target="_blank"
                href="https://vuetifyjs.com"
                class="dialog-conditions__link"
              >
                Termos de acordo
              </a>
              e
              <a
                target="_blank"
                href="https://google.com"
                class="dialog-conditions__link"
              >
                Informações Legais.
              </a>
              Danos causados por instalações e manutenções não credenciadas implicam na perda de garantia.
              <a
                target="_blank"
                href="https://google.com"
                class="dialog-conditions__link"
              >
                Veja o termo.
              </a>
            </div>
          </template>
        </v-checkbox>
      </v-container> -->

      <v-card-actions
        class="service-dialog__actions pa-0 ma-0 mt-1"
      >
        <v-btn
          class="service-dialog__btn"
          medium
          depressed
          color="#140C22"
          :disabled="(!valid || !getServiceSelected)"
          @click="addServices()"
        >
          Continuar
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import orderBy from 'lodash.orderby';

export default {
  props: {
    product: {
      type: Object,
      default: () => {},
    },
    quantity: {
      type: Number,
      default: 0,
    },
  },

  data: () => ({
    selectedNoService: false,
    selectedServices: [],
    valid: null,
    unitiesToApply: undefined,
  }),

  computed: {
    getServices() {
      let skuAddOnsWithRecommended = this.product.skus[0].sku_add_ons.filter((skuAddOn) => skuAddOn.type === 'PS' && skuAddOn.store_id === this.product.store_id).map((skuAddOn) => ({
        sku_add_on_id: skuAddOn.id,
        title: `+ ${skuAddOn.plan} ${skuAddOn.plan > 1 ? 'Meses' : 'Mês'}`,
        subtitle: skuAddOn.description || 'Serviço e Instalações',
        price: skuAddOn.price_plan,
        installments: `em até 10x de ${(skuAddOn.price_plan / 10).toFixed(2)}`,
        recommended: false,
      }));

      if (skuAddOnsWithRecommended.length) {
        const skuAddOnWithMaxPlan = skuAddOnsWithRecommended.reduce((prev, current) => ((prev.plan > current.plan) ? prev : current));

        skuAddOnsWithRecommended = skuAddOnsWithRecommended.map((skuAddOn) => ({
          ...skuAddOn,
          recommended: skuAddOn.price === skuAddOnWithMaxPlan.price,
        }));

        return orderBy(skuAddOnsWithRecommended, 'price');
      }

      return [];
    },

    getServiceSelected() {
      return !!this.selectedServices.length || this.selectedNoService;
    },

    getQuantities() {
      const items = [{
        value: this.quantity,
        text: 'Todas as unidades',
      }];
      // eslint-disable-next-line no-plusplus
      for (let i = 1; i <= this.quantity; i++) {
        items.push({ value: i, text: i });
      }
      return items;
    },
  },

  watch: {
    quantity() {
      // eslint-disable-next-line prefer-destructuring
      this.unitiesToApply = this.getQuantities[0];
    },
  },

  mounted() {
    // eslint-disable-next-line prefer-destructuring
    this.unitiesToApply = this.getQuantities[0];
  },

  methods: {
    addServices() {
      this.$set(this.product, 'services', this.selectedServices);
      this.$emit('update-product', this.productIdx, this.product);
      this.$emit('change-quantity-services', typeof this.unitiesToApply === 'number' ? this.unitiesToApply : this.unitiesToApply.value);
      this.$emit('finish-services');
      this.$store.dispatch('refreshCatalogue');
      this.close();
    },

    close() {
      this.$emit('close', false);
    },
  },
};
</script>

<style scoped lang="scss">
.service-dialog {
  padding: 0px 20px 40px 20px;
  text-transform: none;
  border-radius: 7px;
  color: #140C22;
  box-sizing: border-box;
  &__title {
    font-family: 'Nunito Sans';
    font-weight: 600;
    font-size: 18px;
    line-height: 25px;
    text-transform: uppercase;
  }
  &__txt {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    text-transform: none;
  }
  &__actions {
    align-items: center;
    justify-content: center;
  }
  &__btn {
    width: 290px;
    height: 38px;
    border-radius: 7px;
    text-transform: none;
    font-weight: 600;
    color: #FFFFFF;
  }
  &__close {
    display: flex;
    justify-content: end;
    transform: translateX(20px);
  }
}

.dialog-container {
  padding: 0px;
}

.dialog-checkbox{
  width: 104%;
  border: 1px solid rgba(20, 12, 34, 0.25);
  border-radius: 7px;
  padding: 0px;
  min-height: 58px;
  box-sizing: border-box;
  &__wrapper {
    margin-left: 3PX;
    margin-right: 3px;
    &__title {
      color: #140C22;
      display: block;
      font-family: 'Nunito Sans';
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
    }
    &__txt {
      color: #8A8691;
      display: block;
      font-family: 'Nunito Sans';
      font-style: normal;
      font-weight: 600;
      font-size: 10px;
      line-height: 14px;
    }
    &__link {
      color: #046CB8;
      font-family: 'Nunito Sans';
      font-style: normal;
      font-weight: 600;
      font-size: 10px;
      line-height: 13px
    }
  }
}

.v-input--selection-controls {
  margin-right: 10px;
  margin-left: 10px;
}

.dialog-conditions {
  padding: 0px;
  &__txt {
    font-family: 'Nunito Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    color: rgba(20, 12, 34, 0.5);
  }
  &__link {
    color: #046CB8;
  }
}

::v-deep .dialog-conditions .v-input__slot {
  align-items: flex-start;
}

</style>
